// Vendor libraries
import { ElementRef, inject } from '@angular/core';
// Utils
import { getOwnerDisplayName } from 'SharingApp/ts/utils/sharing-utils';
// Services
import { BulkActionSelectionService } from 'FoldersApp/services/bulk-action-selection.service';
import * as i0 from "@angular/core";
// TODO: Rename this FolderableBase to ContentItemBase. Then move common code for ContentItemBase & FolderBase into
//  a new class named FolderableBase. Common code: checked, ancestorFolderIsSelected.
/**
 * Base class for a component that represents an item that can be in a folder.
 */
export class FolderableBase {
    constructor() {
        this.bulkActionSelectionService = inject(BulkActionSelectionService);
        this.elementRef = inject(ElementRef);
    }
    get checked() {
        if (this.ancestorFolderIsSelected &&
            this.bulkActionSelectionService.isSelected(this.folderable.resourceType, this.folderable.item.id)) {
            // When an ancestor folder is selected, assume all sub-items are included as part of its selection.
            this.bulkActionSelectionService.deselectItem(this.folderable.resourceType, this.folderable.item.id);
        }
        return this.bulkActionSelectionService.isSelected(this.folderable.resourceType, this.folderable.item.id);
    }
    get relativePositionedElemId() {
        return `list-item-dropdown-${this.folderable.resourceType}-${this.folderable.item.id}`;
    }
    get ownerName() {
        return getOwnerDisplayName(this.folderable.item.sharing);
    }
    get itemUrl() {
        return null;
    }
    // TODO: rename to enableItemSelection
    get enableItemUrl() {
        return false;
    }
    get itemSelectionDisabled() {
        if (!this.bulkActionSelectionService.bulkActionMode)
            return false;
        return this.folderable.item.sharing.owner_id !== window.USER.userId || this.ancestorFolderIsSelected;
    }
    get ancestorFolderIsSelected() {
        // If there is a disabled ancestor, then an ancestor folder has been selected.
        // We use the css `disabled` class to detect whether an ancestor has been selected as a simpler alternative
        // to managing a mapping of ancestor to child item types and ids.
        const { nativeElement } = this.elementRef;
        return nativeElement.closest('.disabled') !== null;
    }
    openInNewTab() {
        if (!this.itemUrl)
            return;
        // eslint-disable-next-line no-unused-expressions
        window.open(this.itemUrl, '_blank')?.focus();
    }
}
FolderableBase.ɵfac = function FolderableBase_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableBase)(); };
FolderableBase.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: FolderableBase, inputs: { folderable: "folderable", ancestorInfo: "ancestorInfo" } });
